import React from 'react';
import c from 'classnames';
import ModalHeadingText from '../ModalHeadingText';
import ModalSubText from '../ModalSubText';
import s from './ModalHeader.scss';

interface Props {
  /**
   * Displayed on the left at the top of the header inside of a `<ModalHeadingText />`
   */
  heading: React.ReactNode;

  /**
   * Displayed below `heading` inside of a `<ModalSubText />`
   */
  subheading?: React.ReactNode;

  /**
   * A slot for the left side of the header
   *
   * Some specs have a Back button here
   */
  left?: React.ReactNode;

  /**
   * A slot for the right side of the header
   *
   * Some specs have `Changes not saved` text here
   */
  right?: React.ReactNode;

  /**
   * A `className` that we put on the root `<div />` tag
   */
  className?: string;
}

/**
 * The top portion of a modal. It has a heading and -- optionally -- a subheading and right-side slot.
 */
const ModalHeader: React.FC<Props> = ({ heading, subheading, left, right, className }) => {
  return (
    <div className={c(s['root'], className)}>
      {left && <div className={s['left']}>{left}</div>}
      <div className={s['heading-and-subheading-block']}>
        <ModalHeadingText>{heading}</ModalHeadingText>
        {subheading && <ModalSubText>{subheading}</ModalSubText>}
      </div>
      <div className={s['right']}>{right}</div>
    </div>
  );
};
ModalHeader.displayName = 'ModalHeader';

export default ModalHeader;
